
import './App.css';
import Navbar from './Component/Layout/Navbar';
import Home from './Component/Home/Home';
import Service from './Component/Service/Service';
import AboutUs from './Component/About/AboutUs';
import Expertise from './Component/Expertise/Expertise';
import Offer from './Component/Offer/Offer';
import TechStack from './Component/TechStack/TechStack';
import Whywork from './Component/Whywork/Whywork';
import Contact from './Component/Contact/Contact';
import Footer from './Component/Layout/Footer';
import { ToastContainer } from 'react-toastify';


import Careers from './Component/Careers/Careers';
import { BrowserRouter, Route, Routes } from 'react-router';
import Location from './Component/Location/Location';
import Privacy from './Component/PrivacyPolicy/Privacy';
import Servicelist from './Component/Service/Servicelist';




function App() {
  return (
    <BrowserRouter>
      <Routes>
        <>

          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <Service />
              <AboutUs />
              <Expertise />
              <Offer />

              <TechStack />
              <Whywork />
              <Location />
              <Contact />
              <Footer />

            </>
          } />
        </>
        <Route path="/service/:title" element={<Servicelist />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="privacy" element={<Privacy />} />

      </Routes>
      <ToastContainer position='top-center' autoClose='2000' />
    </BrowserRouter>

  );
}

export default App;
